'use client';

import { PracticeProgramCardData } from '@/types/curriculum-program.type';

interface PracticeProgramCardProps {
  data?: PracticeProgramCardData;
}

export default function PracticeProgramCard({
  data,
}: PracticeProgramCardProps) {
  if (!data) return null;

  const { subtitle, title, checkListItems, prices, discountBanner } = data;
  return (
    <div className="desktop:px-[60px] desktop:py-[48px] desktop:shadow-lg desktop:items-between desktop:mx-0 desktop:flex-row mx-5 box-border flex flex-col rounded-xl bg-white px-6 py-8 shadow-md">
      {/* 내용 영역 */}
      <div className="desktop:gap-[32px] flex flex-col gap-6">
        {/* 제목 영역 */}
        <div className="flex flex-col">
          <span className="desktop:typo-20 typo-16 text-main-orange desktop:mb-3 mb-2 font-extrabold">
            {subtitle}
          </span>
          <span className="desktop:typo-32 typo-24 text-level-1 font-extrabold">
            {title}
          </span>
        </div>
        {/* 왼쪽: 체크리스트 */}
        <div className="desktop:gap-2 flex flex-col gap-2">
          {checkListItems.map((item: string) => (
            <div key={item} className="desktop:gap-3 flex items-center gap-1">
              <div className="desktop:mt-1 desktop:h-5 desktop:w-5 mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.6667 5L7.50004 14.1667L3.33337 10"
                    stroke="#999999"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <span className="desktop:typo-20 typo-16 text-level-2 desktop:leading-relaxed font-semibold">
                {item}
              </span>
            </div>
          ))}
        </div>
      </div>
      {/* 오른쪽: 가격 정보 */}
      <div className="desktop:flex-1 desktop:flex-col desktop:items-end desktop:justify-end flex flex-col justify-center gap-4">
        {/* 할인 배너 */}
        {discountBanner ? (
          <div className="desktop:mb-4 desktop:w-[320px] desktop:mt-0 mt-6 mb-3 w-full">
            <div className="bg-main-orange desktop:typo-18 desktop:w-[320px] typo-16 flex h-[40px] items-center justify-center rounded-lg px-4 py-2 text-center font-bold text-white">
              {discountBanner}
            </div>
          </div>
        ) : (
          <div className="h-0"></div>
        )}
        {/* 가격 리스트 */}
        <div className="desktop:flex-col desktop:gap-4 flex flex-col gap-4">
          {prices.map((item, index) => (
            <div
              key={index}
              className="desktop:gap-6 flex items-center justify-between gap-4"
            >
              <span className="desktop:typo-24 typo-15 text-level-5 font-bold">
                {item.type}
              </span>
              <div className="flex items-center gap-2">
                {item.originalPrice && (
                  <span className="desktop:typo-20 typo-14 font-bold text-[#BBBBBB] line-through">
                    {item.originalPrice}
                  </span>
                )}
                <span className="desktop:typo-32 typo-24 text-level-1 desktop:min-w-[100px] desktop:text-right inline-block font-extrabold">
                  {item.price}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
